export const PUBLISHING_EMAIL = "publishing@ezgames.cc";
export const CONTACT_CC_EMAIL = "robert@ezgames.cc";
export const CONTACT_PHONE_DISPLAY = "+84795029690";
export const CONTACT_PHONE_HREF = "tel:+84795029690";
